import './WebGis.scss';
import React from 'react';
import { Bgis } from '../../bgis/components/Bgis';
import { BgisBody } from '../../bgis/components/BgisBody';
import { BgisMap, BgisHideHeader, BgisToggleSidebar, BgisMapArea } from '../../bgis/components/maparea';
import { BgisSidebar } from '../../bgis/components/maparea/sidebar';
import { BgisLegend } from '../../bgis/components/maparea/sidebar/menus/legend';
import { BgisDetails } from '../../bgis/components/maparea/sidebar/details';
import { MapDetailBody } from './MapDetailBody';
import { LegendLayers } from './LegendLayers';
import { LegendInfos } from './LegendInfos';
import { BgisMenus } from '../../bgis/components/maparea/sidebar/menus';
import { SearchDetailBody } from './SearchDetailBody';
import { Search } from './Search';
import { Map } from 'ol';
 
import { BgisBasemap,  BgisBasemapLayers } from '../../bgis/components/maparea/basemap';
import { basemapGrayLayer, basemapOrthofotoLayer, noBasemapLayer } from '../layers';

/* The basemap icons */
import basemapOrthofotoIcon from '../../img/basemap/basemap_dop.png';
import basemapGrayIcon from '../../img/basemap/basemap_grau.png';
import noBasemapIcon from '../../img/basemap/basemap_leer.png';

interface WebGisProps {
    map: Map
}

const WebGis: React.FC<WebGisProps> = ({ map }) => {




    return (

        <Bgis>
            <BgisBody>
                <BgisMapArea showToolbar={true} showLegend={true}>
                    <BgisSidebar>
                        <BgisMenus>
                            <Search></Search>
                            <BgisLegend description="Kartendetails" title="Legende">
                                <LegendLayers></LegendLayers>
                                <LegendInfos></LegendInfos>
                            </BgisLegend>

                        </BgisMenus>

                        <BgisDetails>
                            <MapDetailBody></MapDetailBody>
                            <SearchDetailBody></SearchDetailBody>

                        </BgisDetails>
                    </BgisSidebar>
                    <BgisToggleSidebar></BgisToggleSidebar>
                    <BgisHideHeader></BgisHideHeader>
                    <BgisMap map={map} id="h2owebgis-map" />
                    <BgisBasemap>
                        <span className='bgis-hz'>
                            <BgisBasemapLayers layers={[
                                { id: "basemapGray", icon: basemapGrayIcon, label: "Basemap Grau", layer: basemapGrayLayer },
                                { id: "basemapOrtho", icon: basemapOrthofotoIcon, label: "Orthofoto", layer: basemapOrthofotoLayer },
                                { id: "noBasemap", icon: noBasemapIcon, label: "Basemap", layer: noBasemapLayer }
                            ]} ></BgisBasemapLayers>
                        </span>
                    </BgisBasemap>
                </BgisMapArea>
            </BgisBody>
             

        </Bgis>
    );
}

export { WebGis };